import React from "react";
import { useTranslation } from 'react-i18next';
import { Box, Grid, Typography } from "@mui/material";
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import Logo from "../Logo";
import ThemeModeToggle from "../ThemeModeToggle";

const AuthLayout = ({ children }) => {
    const { t } = useTranslation();
    const valuePropKeys = ['heroPoint1', 'heroPoint2', 'heroPoint3', 'heroPoint4'];

    return (
        <Grid container sx={{ minHeight: '100vh' }}>
            <Grid item xs={12} md={6}>
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        minHeight: '100vh',
                        position: 'relative',
                        px: 3,
                        py: 4,
                        bgcolor: (theme) => theme.custom.pageBg,
                    }}
                >
                    <Box sx={{ position: 'absolute', top: 16, right: 16 }}>
                        <ThemeModeToggle />
                    </Box>
                    <Box sx={{ width: '100%', maxWidth: 420 }}>
                        <Box sx={{ textAlign: 'center', mb: 4 }}>
                            <Logo size="64px" />
                        </Box>
                        {children}
                    </Box>
                </Box>
            </Grid>
            <Grid
                item
                md={6}
                sx={{
                    display: { xs: 'none', md: 'flex' },
                    alignItems: 'center',
                    justifyContent: 'center',
                    bgcolor: (theme) => theme.palette.primary.main,
                    color: '#fff',
                    p: 6,
                }}
            >
                <Box sx={{ maxWidth: 440 }}>
                    <Typography variant="h4" sx={{ fontWeight: 700, mb: 2, lineHeight: 1.3 }}>
                        {t('auth.heroTitle')}
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 4, opacity: 0.9 }}>
                        {t('auth.heroSubtitle')}
                    </Typography>
                    <Box sx={{ mb: 4 }}>
                        {valuePropKeys.map((key) => (
                            <Box key={key} sx={{ display: 'flex', alignItems: 'center', mb: 1.5 }}>
                                <CheckCircleOutlineIcon sx={{ mr: 1.5, fontSize: 22 }} />
                                <Typography variant="body1">{t('auth.'+key)}</Typography>
                            </Box>
                        ))}
                    </Box>
                    <Typography variant="body2" sx={{ opacity: 0.85 }}>
                        {t('auth.trustedBy')}
                    </Typography>
                </Box>
            </Grid>
        </Grid>
    );
};

export default AuthLayout;
